import type {
  FocusEventHandler,
  KeyboardEventHandler,
  MouseEventHandler,
  ReactNode,
} from 'react';
import { forwardRef } from 'react';

import SelectFocus from '../Select/SelectFocus';

type MultiSelectAnchorProps = {
  children: ReactNode;
  disabled: boolean;
  onClick: MouseEventHandler;
  onBlur: FocusEventHandler;
  onKeyUp: KeyboardEventHandler;
  onKeyDown: KeyboardEventHandler;
};

const MultiSelectAnchor = forwardRef<Element, MultiSelectAnchorProps>(
  function MultiSelectAnchor(props, ref) {
    return (
      <SelectFocus
        rcx-input-box--undecorated
        ref={ref}
        aria-haspopup='listbox'
        order={1}
        {...props}
      />
    );
  },
);

export default MultiSelectAnchor;
